import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './app.css';
import './analyticsConsent';
import { TrustLandingPage } from './TrustLandingPage';
import { TrustProfilePage } from './TrustProfilePage';

const rootBasename = import.meta.env.BASE_URL.replace(/\/$/, '') || '/';

const App = () => (
  <BrowserRouter basename={rootBasename}>
    <Routes>
      <Route path="/" element={<TrustLandingPage />} />
      <Route path="/:slug" element={<TrustProfilePage />} />
    </Routes>
  </BrowserRouter>
);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
